export enum TriggerActionsState {
    conditions = 'conditions',
    actions = 'actions',
}

export enum OnChangeStateTypeValues {
    input = 'input',
    keep_value = 'keep_value',
    delete_array_value = 'delete_array_value',
    add_array_value = 'add_array_value',
}

export enum FieldConditions {
    multipleSelect = 'multiple-select',
    singleSelect = 'single-select',
    dropdown = 'dropdown',
    input = 'input',
}
